import gql from 'graphql-tag';
import collegeEventLocationFragment from './collegeEventLocationFragment';

export default gql`
  mutation deleteCollegeEventLocation($input: deleteCollegeEventLocationInput!) {
    deleteCollegeEventLocation(input: $input) {
      viewer {
        id
        eventLocations {
          ...CollegeEventLocation
        }
      }
    }
  }
  ${collegeEventLocationFragment}
`;
